interface IMoneyFormatOptions {
  style?: 'currency' | 'decimal'
  currency?: string
  hasDecimals?: boolean
}

export function formatMoney(
  centsValue: number,
  options?: IMoneyFormatOptions,
): string {
  const hasDecimals = options?.hasDecimals ?? true
  const value = hasDecimals ? centsValue / 100 : centsValue

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    ...options,
  }).format(value)
}
